export const regexEmail =
/^[a-z0-9" "!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
export const regexEmailCaracteres = /^[a-zA-Z0-9@._\-!#$%&'*+/=?^`{|}~]*$/;
export const regexNombre = /^[a-zA-ZáéíóúAÉÍÓÚÑñ ]+(\s+[a-zA-ZáéíóúAÉÍÓÚÑñ]+)*$/;
export const regexNombreCaracteres = /^[a-zA-ZáéíóúAÉÍÓÚÑñ ]*$/;
export const regexNumero = /^([0-9])*$/;
export const regexTelefono = /^[0-9\s]*$/;
export const regexNumeroLetras = /^[A-Za-z0-9 _]*[A-Za-z0-9 _]*$/;
export const regexUserLogin = /^[0-9a-zA-Z]+$/;
export const regexDomicilio = /^[a-zA-Z0-9áéíóúAÉÍÓÚÑñ\s.,°º\-]*$/;



